module.exports = __webpack_public_path__ + "static/media/plans-desktop.09ccbbeb.png";